export default "__VITE_ASSET__C54Afa2F__"